import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import CampaignInfSidebarNavLinks from './CampaignInfSidebarNavLinks'

export default observer(function CampaignInfluencerSidebarNavBase({ links = [] }) {
  const [activePath, setActivePath] = useState('')
  const location = useLocation()

  useEffect(() => {
    const currentPath = links.find(link => location.pathname.includes(link.key))
    setActivePath(currentPath?.key || '')
  }, [location.pathname, links])

  return (
    <div className="flex border-b-1 px-2">
      {links.map((link) => (
        <CampaignInfSidebarNavLinks
          key={link.key}
          text={link.text}
          link={link.href}
          active={activePath === link.key}
        />
      ))}
    </div>
  )
})
